import styled from 'styled-components';

interface ClockListContainerProps {
  hasHeader?: boolean;
}

export const ClockListContainer = styled.div<ClockListContainerProps>`
  padding-top: ${({ hasHeader }) => hasHeader ? 0 : 10}px;
  background-color: white;
`;